import { getMasterData } from "@api/masterData";
import { useEffect, useState } from "react";

export const useMasterData = (
  id: string,
  defaultParams?: Record<string, any>, // Added optional queryParams
) => {
  const [data, setData] = useState<any>([]);
  const [queryParams, setQueryParams] = useState<
    Record<string, any> | undefined
  >(defaultParams);

  const getQueryParams = (params: Record<string, any>) => {
    setQueryParams(params);
  };

  useEffect(() => {
    if (id && queryParams) {
      getMasterData(id, queryParams)
        .then((data) => setData(data.data))
        .catch((err) => console.log(err));
    } else if (id) {
      getMasterData(id)
        .then((data) => setData(data.data))
        .catch((err) => console.log(err));
    }

    return () => setData([]); // Fixed cleanup function
  }, [id, queryParams]); // Added queryParams to dependencies

  return {
    data,
    getQueryParams,
  };
};
